import React from "react";

const AIFace = () => {
  return (
    <div style={{ color: "white", fontFamily: "Arial, sans-serif" }}>
      <h2 style={{ color: "#00ffff", borderBottom: "2px solid #00ffff", paddingBottom: "10px" }}>
        🧠 Artificial Intelligence
      </h2>
      <p style={{ marginTop: "15px", opacity: 0.9 }}>
        Implementación de modelos de aprendizaje automático y procesamiento de lenguaje natural (NLP) para optimizar procesos y análisis de datos en tiempo real.
      </p>
      <div style={{ marginTop: "20px" }}>
        <h3 style={{ color: "#00ffff", fontSize: "16px" }}>Expertise:</h3>
        <ul style={{ fontSize: "14px", opacity: 0.8 }}>
          <li>Integración de LLMs (GPT-4, Claude) en flujos empresariales.</li>
          <li>Agentes IA autónomos para análisis de mercados.</li>
          <li>Computer Vision para automatización de seguridad.</li>
        </ul>
      </div>
      <div style={{ marginTop: "25px", padding: "15px", background: "rgba(0, 255, 255, 0.1)", borderRadius: "12px", border: "1px dashed #00ffff" }}>
        <h4 style={{ margin: "0 0 10px 0", color: "#00ffff", fontSize: "14px" }}>🚀 Producto de FrancoLab:</h4>
        <p style={{ fontSize: "13px", margin: "0 0 10px 0" }}>
          <strong>FrancoIntelligence:</strong> Un agente de IA que audita la lógica de negocios de dApps en segundos.
        </p>
        <a href="#" style={{ color: "#00ffff", fontSize: "13px", fontWeight: "bold", textDecoration: "none" }}>Ver Demo IA →</a>
      </div>
    </div>
  );
};

export default AIFace;